import * as React from "react";
const SvgFiRrShare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-share_svg__a)">
      <path
        fill="#062147"
        d="M19.333 14.667a4.66 4.66 0 0 0-3.839 2.024l-6.509-2.939a4.57 4.57 0 0 0 .005-3.488l6.5-2.954a4.66 4.66 0 1 0-.827-2.643q.006.397.08.786l-6.91 3.14a4.668 4.668 0 1 0-.015 6.827l6.928 3.128a5 5 0 0 0-.079.785 4.667 4.667 0 1 0 4.666-4.666m0-12.667a2.667 2.667 0 1 1 .002 5.335A2.667 2.667 0 0 1 19.333 2M4.667 14.667a2.667 2.667 0 1 1-.002-5.334 2.667 2.667 0 0 1 .002 5.334M19.333 22a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-share_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShare;
